// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.history-gallery {
  position: fixed;
  inset: 0;
  height: 100%;
  overflow-y: auto;
  touch-action: pan-y !important;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
  background:
    linear-gradient(180deg, rgba(36, 129, 204, 0.08) 0%, rgba(36, 129, 204, 0.02) 90px, transparent 180px),
    var(--tg-theme-bg-color, #ffffff);
  color: var(--tg-theme-text-color, #111111);
  z-index: 1500;
}

.history-gallery * {
  touch-action: pan-y;
}

.history-gallery-shell {
  min-height: 100%;
  padding: 6px 6px 12px;
  box-sizing: border-box;
}

.history-gallery-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin: 0 auto 8px;
  max-width: 920px;
  padding: 8px 8px 2px;
}

.history-gallery-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
}

.history-gallery-title-block {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.history-gallery-title {
  margin: 0;
  font-size: 24px;
  line-height: 1.05;
  font-weight: 700;
  color: var(--tg-theme-button-color, #2481cc);
}

.history-gallery-show-all {
  flex-shrink: 0;
  border: 0;
  border-radius: 14px;
  padding: 7px 10px;
  margin-top: 2px;
  background: rgba(36, 129, 204, 0.14);
  color: var(--tg-theme-button-color, #2481cc);
  font-size: 12px;
  line-height: 1;
  font-weight: 700;
  cursor: pointer;
}

.history-gallery-subtitle {
  margin: 0;
  max-width: 460px;
  color: var(--tg-theme-text-color, #111111);
  opacity: 0.78;
  font-size: 14px;
  line-height: 1.35;
}

.history-gallery-search {
  width: 100%;
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: max-height 0.25s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.18s ease, margin 0.25s ease;
}

.history-gallery-search.is-visible {
  max-height: 72px;
  opacity: 1;
  margin-bottom: 2px;
}

.history-gallery-search-shell {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: 100%;
  min-height: 50px;
  padding: 0 14px;
  box-sizing: border-box;
  border-radius: 22px;
  border: 2px solid var(--tg-theme-button-color, #2481cc);
  background: var(--tg-theme-bg-color, #ffffff);
}

.history-gallery-search-icon {
  flex-shrink: 0;
  font-size: 22px;
  color: #111111;
}

.history-gallery-search-input {
  width: 100%;
  min-width: 0;
  border: 0;
  background: transparent;
  color: var(--tg-theme-text-color, #111111);
  font-size: 16px;
  line-height: 1;
  outline: none;
}

.history-gallery-search-input::placeholder {
  color: var(--tg-theme-hint-color, #6b6b6b);
}

.history-gallery-search-clear,
.history-gallery-search-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  cursor: pointer;
}

.history-gallery-search-clear {
  width: 26px;
  height: 26px;
  padding: 0;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.06);
  color: var(--tg-theme-text-color, #111111);
  flex-shrink: 0;
}

.history-gallery-tabs-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.history-gallery-search-toggle {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  background: transparent;
  color: var(--tg-theme-hint-color, #9a9a9a);
  font-size: 28px;
  font-weight: 700;
  padding: 0;
  margin-top: -2px;
  line-height: 1;
}

.history-gallery-search-toggle.is-active {
  color: var(--tg-theme-button-color, #2481cc);
}

.history-gallery-filters {
  display: flex;
  gap: 11px;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 0 4px;
  max-height: none;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.history-gallery-filters::-webkit-scrollbar {
  display: none;
}

.history-gallery-filter {
  border: 0;
  border-radius: 0;
  padding: 2px 0 4px;
  background: transparent;
  color: var(--tg-theme-hint-color, #9a9a9a);
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  position: relative;
}

.history-gallery-filter.is-active {
  background: transparent;
  color: var(--tg-theme-button-color, #2481cc);
}

.history-gallery-filter.is-active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -5px;
  height: 4px;
  border-radius: 4px 4px 0 0;
  background: var(--tg-theme-button-color, #2481cc);
}

.history-gallery-retry {
  border: 0;
  border-radius: 10px;
  padding: 9px 11px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  background-color: var(--tg-theme-button-color, #2481cc);
  color: var(--tg-theme-button-text-color, #ffffff);
}

.history-masonry {
  max-width: 920px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.history-masonry-column {
  display: flex;
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
}

.history-card {
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  border-radius: 12px;
  background: var(--tg-theme-bg-color, #ffffff);
  color: inherit;
  text-align: left;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.14);
  cursor: pointer;
}

.history-card:active {
  transform: scale(0.985);
}

.history-card-media {
  position: relative;
  width: 100%;
  height: 0;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.05);
}

.history-card-image,
.history-card-fallback {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.history-card-image {
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.25s ease;
}

.history-card-image.is-loaded {
  opacity: 1;
}

.history-card-skeleton {
  position: absolute;
  inset: 0;
  background: linear-gradient(110deg, rgba(0,0,0,0.03) 25%, rgba(0,0,0,0.08) 45%, rgba(0,0,0,0.03) 65%);
  background-size: 220% 100%;
  animation: historyShimmer 1.4s linear infinite;
}

.history-card-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  box-sizing: border-box;
  color: var(--tg-theme-hint-color, #6b6b6b);
  font-size: 11px;
  line-height: 1.25;
  text-align: center;
}

.history-card-meta {
  padding: 6px 7px 7px;
}

.history-card-title {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  color: var(--tg-theme-text-color, #111111);
  word-break: break-word;
}

.history-card-date {
  margin-top: 2px;
  font-size: 10px;
  color: var(--tg-theme-hint-color, #6b6b6b);
}

.history-gallery-state,
.history-gallery-footer {
  max-width: 920px;
  margin: 0 auto;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 12px 6px;
  color: var(--tg-theme-text-color, #111111);
  opacity: 0.86;
}

.history-gallery-footer {
  padding-top: 6px;
  padding-bottom: 4px;
}

.history-gallery-spinner {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.12);
  border-top-color: var(--tg-theme-button-color, #2481cc);
  animation: historySpin 0.8s linear infinite;
}

.history-gallery-sentinel {
  height: 1px;
}

@keyframes historySpin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes historyShimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@media (max-width: 640px) {
  .history-gallery-shell {
    padding: 4px 4px 10px;
  }

  .history-gallery-header {
    padding: 8px 8px 2px;
  }

  .history-gallery-title {
    font-size: 22px;
  }

  .history-gallery-title-row {
    gap: 8px;
  }

  .history-gallery-show-all {
    padding: 6px 9px;
    font-size: 11px;
  }

  .history-gallery-search.is-visible {
    max-height: 68px;
  }

  .history-gallery-search-shell {
    min-height: 46px;
    padding: 0 14px;
    border-width: 2px;
  }

  .history-gallery-search-input {
    font-size: 15px;
  }

  .history-gallery-filters {
    gap: 10px;
  }

  .history-gallery-search-toggle {
    margin-top: -1px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/history/HistoryGallery.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;EAC9B;;qCAEmC;EACnC,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,oCAAoC;EACpC,4CAA4C;EAC5C,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,iGAAiG;AACnG;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,uDAAuD;EACvD,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,+BAA+B;EAC/B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uDAAuD;EACvD,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,6CAA6C;EAC7C,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qGAAqG;EACrG,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0CAA0C;AAC5C;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,uDAAuD;EACvD,2CAA2C;AAC7C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".history-gallery {\n  position: fixed;\n  inset: 0;\n  height: 100%;\n  overflow-y: auto;\n  touch-action: pan-y !important;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior-y: contain;\n  background:\n    linear-gradient(180deg, rgba(36, 129, 204, 0.08) 0%, rgba(36, 129, 204, 0.02) 90px, transparent 180px),\n    var(--tg-theme-bg-color, #ffffff);\n  color: var(--tg-theme-text-color, #111111);\n  z-index: 1500;\n}\n\n.history-gallery * {\n  touch-action: pan-y;\n}\n\n.history-gallery-shell {\n  min-height: 100%;\n  padding: 6px 6px 12px;\n  box-sizing: border-box;\n}\n\n.history-gallery-header {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0 auto 8px;\n  max-width: 920px;\n  padding: 8px 8px 2px;\n}\n\n.history-gallery-title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  width: 100%;\n}\n\n.history-gallery-title-block {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.history-gallery-title {\n  margin: 0;\n  font-size: 24px;\n  line-height: 1.05;\n  font-weight: 700;\n  color: var(--tg-theme-button-color, #2481cc);\n}\n\n.history-gallery-show-all {\n  flex-shrink: 0;\n  border: 0;\n  border-radius: 14px;\n  padding: 7px 10px;\n  margin-top: 2px;\n  background: rgba(36, 129, 204, 0.14);\n  color: var(--tg-theme-button-color, #2481cc);\n  font-size: 12px;\n  line-height: 1;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.history-gallery-subtitle {\n  margin: 0;\n  max-width: 460px;\n  color: var(--tg-theme-text-color, #111111);\n  opacity: 0.78;\n  font-size: 14px;\n  line-height: 1.35;\n}\n\n.history-gallery-search {\n  width: 100%;\n  max-height: 0;\n  opacity: 0;\n  overflow: hidden;\n  transition: max-height 0.25s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.18s ease, margin 0.25s ease;\n}\n\n.history-gallery-search.is-visible {\n  max-height: 72px;\n  opacity: 1;\n  margin-bottom: 2px;\n}\n\n.history-gallery-search-shell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  max-width: 100%;\n  min-height: 50px;\n  padding: 0 14px;\n  box-sizing: border-box;\n  border-radius: 22px;\n  border: 2px solid var(--tg-theme-button-color, #2481cc);\n  background: var(--tg-theme-bg-color, #ffffff);\n}\n\n.history-gallery-search-icon {\n  flex-shrink: 0;\n  font-size: 22px;\n  color: #111111;\n}\n\n.history-gallery-search-input {\n  width: 100%;\n  min-width: 0;\n  border: 0;\n  background: transparent;\n  color: var(--tg-theme-text-color, #111111);\n  font-size: 16px;\n  line-height: 1;\n  outline: none;\n}\n\n.history-gallery-search-input::placeholder {\n  color: var(--tg-theme-hint-color, #6b6b6b);\n}\n\n.history-gallery-search-clear,\n.history-gallery-search-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  cursor: pointer;\n}\n\n.history-gallery-search-clear {\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.06);\n  color: var(--tg-theme-text-color, #111111);\n  flex-shrink: 0;\n}\n\n.history-gallery-tabs-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.history-gallery-search-toggle {\n  width: 44px;\n  height: 44px;\n  flex-shrink: 0;\n  background: transparent;\n  color: var(--tg-theme-hint-color, #9a9a9a);\n  font-size: 28px;\n  font-weight: 700;\n  padding: 0;\n  margin-top: -2px;\n  line-height: 1;\n}\n\n.history-gallery-search-toggle.is-active {\n  color: var(--tg-theme-button-color, #2481cc);\n}\n\n.history-gallery-filters {\n  display: flex;\n  gap: 11px;\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 0 0 4px;\n  max-height: none;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.history-gallery-filters::-webkit-scrollbar {\n  display: none;\n}\n\n.history-gallery-filter {\n  border: 0;\n  border-radius: 0;\n  padding: 2px 0 4px;\n  background: transparent;\n  color: var(--tg-theme-hint-color, #9a9a9a);\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n  position: relative;\n}\n\n.history-gallery-filter.is-active {\n  background: transparent;\n  color: var(--tg-theme-button-color, #2481cc);\n}\n\n.history-gallery-filter.is-active::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -5px;\n  height: 4px;\n  border-radius: 4px 4px 0 0;\n  background: var(--tg-theme-button-color, #2481cc);\n}\n\n.history-gallery-retry {\n  border: 0;\n  border-radius: 10px;\n  padding: 9px 11px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  background-color: var(--tg-theme-button-color, #2481cc);\n  color: var(--tg-theme-button-text-color, #ffffff);\n}\n\n.history-masonry {\n  max-width: 920px;\n  margin: 0 auto;\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.history-masonry-column {\n  display: flex;\n  flex: 1 1 0;\n  min-width: 0;\n  flex-direction: column;\n}\n\n.history-card {\n  display: block;\n  width: 100%;\n  padding: 0;\n  border: 0;\n  border-radius: 12px;\n  background: var(--tg-theme-bg-color, #ffffff);\n  color: inherit;\n  text-align: left;\n  overflow: hidden;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.14);\n  cursor: pointer;\n}\n\n.history-card:active {\n  transform: scale(0.985);\n}\n\n.history-card-media {\n  position: relative;\n  width: 100%;\n  height: 0;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.history-card-image,\n.history-card-fallback {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.history-card-image {\n  object-fit: cover;\n  opacity: 0;\n  transition: opacity 0.25s ease;\n}\n\n.history-card-image.is-loaded {\n  opacity: 1;\n}\n\n.history-card-skeleton {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(110deg, rgba(0,0,0,0.03) 25%, rgba(0,0,0,0.08) 45%, rgba(0,0,0,0.03) 65%);\n  background-size: 220% 100%;\n  animation: historyShimmer 1.4s linear infinite;\n}\n\n.history-card-fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  box-sizing: border-box;\n  color: var(--tg-theme-hint-color, #6b6b6b);\n  font-size: 11px;\n  line-height: 1.25;\n  text-align: center;\n}\n\n.history-card-meta {\n  padding: 6px 7px 7px;\n}\n\n.history-card-title {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--tg-theme-text-color, #111111);\n  word-break: break-word;\n}\n\n.history-card-date {\n  margin-top: 2px;\n  font-size: 10px;\n  color: var(--tg-theme-hint-color, #6b6b6b);\n}\n\n.history-gallery-state,\n.history-gallery-footer {\n  max-width: 920px;\n  margin: 0 auto;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 12px 6px;\n  color: var(--tg-theme-text-color, #111111);\n  opacity: 0.86;\n}\n\n.history-gallery-footer {\n  padding-top: 6px;\n  padding-bottom: 4px;\n}\n\n.history-gallery-spinner {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid rgba(0, 0, 0, 0.12);\n  border-top-color: var(--tg-theme-button-color, #2481cc);\n  animation: historySpin 0.8s linear infinite;\n}\n\n.history-gallery-sentinel {\n  height: 1px;\n}\n\n@keyframes historySpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes historyShimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n@media (max-width: 640px) {\n  .history-gallery-shell {\n    padding: 4px 4px 10px;\n  }\n\n  .history-gallery-header {\n    padding: 8px 8px 2px;\n  }\n\n  .history-gallery-title {\n    font-size: 22px;\n  }\n\n  .history-gallery-title-row {\n    gap: 8px;\n  }\n\n  .history-gallery-show-all {\n    padding: 6px 9px;\n    font-size: 11px;\n  }\n\n  .history-gallery-search.is-visible {\n    max-height: 68px;\n  }\n\n  .history-gallery-search-shell {\n    min-height: 46px;\n    padding: 0 14px;\n    border-width: 2px;\n  }\n\n  .history-gallery-search-input {\n    font-size: 15px;\n  }\n\n  .history-gallery-filters {\n    gap: 10px;\n  }\n\n  .history-gallery-search-toggle {\n    margin-top: -1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
